const get_timezone_names = () => {

  return [
    ["Pacific/Honolulu", 			"(GMT-10:00) US Hawaii"],
    ["America/Anchorage", 			"(GMT-09:00) US Alaska"],
    ["America/Los_Angeles", 		"(GMT-08:00) US Pacific"],
    ["America/Phoenix", 				"(GMT-07:00) US Mountain (No DST)"],
    ["America/Denver", 				"(GMT-07:00) US Mountain West"],
    ["America/Chicago", 				"(GMT-06:00) US Central"],
    ["America/New_York", 			"(GMT-05:00) US Eastern"],
    ["America/Glace_Bay", 				"(GMT-04:00) Atlantic Time (Canada)"],
    ["America/Argentina/Buenos_Aires", "(GMT-03:00) Buenos Aires"],
    ["America/Noronha", 				"(GMT-02:00) Mid-Atlantic"],
    ["Atlantic/Azores", 				"(GMT-01:00) Azores"],
    ["Europe/London", 					"(GMT) London"],
    ["Europe/Berlin", 					"(GMT+01:00) Europe (CET)"],
    ["Africa/Algiers", 				"(GMT+01:00) West Africa"],
    ["Africa/Cairo", 					"(GMT+02:00) Central Africa"],
    ["Africa/Addis_Ababa", 			"(GMT+03:00) East Africa"],
    ["Europe/Moscow", 					"(GMT+03:00) Moscow"],
    ["Asia/Dubai", 					"(GMT+04:00) Abu Dhabi"],
    ["Asia/Karachi", 					"(GMT+05:00) Pakistan"],
    ["Asia/Calcutta", 					"(GMT+05:30) Calcutta"],
    ["Asia/Dhaka", 					"(GMT+06:00) Dhaka"],
    ["Asia/Bangkok", 					"(GMT+07:00) Bangkok"],
    ["Asia/Shanghai", 					"(GMT+08:00) Asia"],
    ["Asia/Tokyo", 					"(GMT+09:00) Tokyo"],
    ["Australia/Brisbane", 			"(GMT+10:00) Brisbane"],
    ["Asia/Magadan", 					"(GMT+11:00) Magadan"],
    ["Pacific/Auckland", 				"(GMT+12:00) Auckland"],
    ["Pacific/Tongatapu", 				"(GMT+13:00) Nuku alofa"],
    ["Pacific/Kiritimati", 			"(GMT+14:00) Kiritimati"],
  ];

};

export default get_timezone_names;
